// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31PaD","right":"styles_right__2akp5"};